import React from 'react';
// nodejs library to set properties for components

import Grid, { type GridProps } from '@mui/material/Grid';

interface GridContainerProps extends GridProps {
  className?: string;
  children?: React.ReactNode;
  align?: 'left' | 'center' | 'right';
}

export default function GridContainer(props: GridContainerProps) {
  const { children, className = '', sx, ...rest } = props;
  return (
    <Grid
      container
      {...rest}
      className={className}
      sx={{
        marginRight: '-15px',
        marginLeft: '-15px',
        width: 'auto',
        ...(sx as object),
      }}
    >
      {children}
    </Grid>
  );
}
